import { Fab, Icon, makeStyles } from "@material-ui/core";

const useStyles = makeStyles({
  flyBtn: {
    position: "absolute",
    top: 0,
    bottom: "auto",
    right: 0,
    left: "auto",
    marginTop: 10,
    marginRight: 10,
    zIndex: 400,
  },
});

const MapFlyBtn = ({ setOpen }) => {
  const classes = useStyles();

  return (
    <Fab
      className={classes.flyBtn}
      variant="circular"
      color="primary"
      size="small"
      centerRipple
      onClick={() => setOpen(true)}
    >
      <Icon>flight</Icon>
    </Fab>
  );
};

export default MapFlyBtn;
